import gql from "graphql-tag";

export const ADD_AREAGROUP = gql`
 mutation insert_areaGroups($id: uuid!,$name: String!,$cityId: uuid!) {
  insert_areaGroups(objects: {id: $id, name: $name, cityId: $cityId}) {
    returning {
      id
 }
}
  }
`

export const UPDATE_AREAGROUP = gql`
 mutation ($areaGroupId: uuid!,$name: String!,$cityId: uuid!) {
   update_areaGroups (where: {id: {_eq: $areaGroupId}}, _set: {name: $name, cityId: $cityId}) {
    returning {
      id
     }
    } 
  }
`
export const DELETE_AREAGROUP = gql`
 mutation ($areaGroupId: uuid!) {
   delete_areaGroups(where: {id: {_eq: $areaGroupId}}) {
    returning {
      id
     }
    }   
  }
`
